<div class="flex items-center justify-between">
  <div class="flex items-center gap-1">
    <lib-health-history-item-icon [iconType]="healthHistoryItem().criticalStatus" [grayedOut]="isUnderDeletion()" />
    <h3 class="typo-h4-medium leading-none" [class.text-text-light]="isUnderDeletion()">{{ healthHistoryItem().description }}</h3>
  </div>
  <div class="flex items-center gap-1">
    <span class="typo-h5-book leading-none" [class.text-text-light]="isUnderDeletion()">
      {{ healthHistoryItemTranslationKey() | translate }}
    </span>
    <div class="typo-h7-medium leading-none text-text-light">
      {{
        healthHistoryItem().activeStatus === 'active'
          ? healthHistoryItem().startedDate.toFormat('MM/dd/yyyy')
          : ('health_history_health_history_tab_item_status_inactive_from'
            | translate: { input1: healthHistoryItem().inactivatedDate?.toFormat('MM/dd/yyyy') })
      }}
    </div>
    @if (hasEditButton()) {
      <button
        (click)="onEditButtonClick()"
        [disabled]="isEditDisabled()"
        [libUiTooltip]="!editHealthHistoryEnabled() ? editDisabledTooltip : undefined"
        tooltipPosition="bottom"
        class="ml-14"
      >
        @if (isNotReady()) {
          <lib-health-history-item-provisional-status-icon
            [provisionalStatus]="healthHistoryItem().provisionalStatus"
            itemType="health-history-item"
          ></lib-health-history-item-provisional-status-icon>
        } @else {
          <svg-icon
            class="max-h-4 max-w-4"
            [ngClass]="isEditDisabled() ? 'text-text-light' : 'text-primary-blue'"
            key="px-16-edit"
          ></svg-icon>
        }
      </button>

      <ng-template #editDisabledTooltip>
        <div class="typo-h7-light max-w-[190px] whitespace-pre-wrap p-1">
          {{ 'health_history_edit_disabled_tooltip' | translate }}
        </div>
      </ng-template>
    }
  </div>
</div>
<lib-text-with-show-more
  class="typo-h4-light font-light leading-5"
  [text]="healthHistoryItem().note"
  [ngClass]="isUnderDeletion() ? 'text-text-light' : 'text-text-secondary'"
></lib-text-with-show-more>
